import { UseFormReturn } from 'react-hook-form';
import { Radio } from '@material-tailwind/react';
import { useAppContext } from 'context/AppContext';

const ParkingTypeInput = (form: UseFormReturn<any, any>) => {
  const { toggles } = useAppContext();

  const { register, watch } = form;
  const { parkingType } = watch();

  return (
    <div className="animate-fade-in">
      <div>
        <Radio
          disabled={!!toggles?.outdoor_disabled}
          id="outdoor"
          value="outdoor"
          defaultChecked={parkingType === 'outdoor'}
          label="Outdoors"
          {...register('parkingType')}
        />
      </div>
      <div>
        <Radio
          disabled={!!toggles?.covered_disabled}
          id="covered"
          value="covered"
          defaultChecked={parkingType === 'covered'}
          label="Indoors"
          {...register('parkingType')}
        />
      </div>
      <div>
        <Radio
          disabled={!!toggles?.motorhome_disabled}
          id="motorhome"
          value="motorhome"
          defaultChecked={parkingType === 'motorhome'}
          label="Motorhome"
          {...register('parkingType')}
        />
      </div>
    </div>
  );
};

export default ParkingTypeInput;
